import React from 'react'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import { GENERAL_STORE, GeneralStore } from 'store'
import {
  LoadingSpinner as LoadingUi,
  LoadingSpinnerProps
} from '@touche-lts/panel-ui/dist/components/shared/loading-spinner'

interface Props extends LoadingSpinnerProps {
  [GENERAL_STORE]?: GeneralStore
}

const LoadingSpinner = (props: Props) => {
  const {
    [GENERAL_STORE]: { loading },
    show,
    ...rest
  } = props

  return <LoadingUi show={loading || show} {...rest} />
}

export default inject(GENERAL_STORE)(observer(LoadingSpinner))
